import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ModelCreatePage } from '@/features/ml/models/model-create-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouveau modèle. Segment statique : gagne sur `$modelId`. */
export const Route = createFileRoute('/$tenant/models/new')({ component: NewModelRoute });

function NewModelRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="models"
      crumbs={[{ label: t('nav.items.models') }, { label: t('ml.models.newTitle') }]}
    >
      <ModelCreatePage tenantId={tenant} />
    </ConsoleShell>
  );
}
